export const DOMAIN_STATUS = {
  'ONLINE': '正常',
  'BANNED': '封禁',
  'FLOOD_CONTROL': '超流量防洪'
}